

































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { timeFormat, setMetaData } from "@/utils/index";
import { ticketClient } from "@/api/index";
import {
  SaveMultilingualReq,
  ListMultilingualReq,
} from "@/pbjs/external/ticket/ticket_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage } from "@/utils/request";

@Component({
  name: "ListMultilingual",
})
export default class ListMultilingual extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private searchForm: any = {
    LanguageKey: "",
    LanguageValue: "",
    Status: "",
    TaskTag: []
  }; 
  @Provide() private isShowDetail: boolean = false;
  @Provide() private isEditId:any = null;

  @Provide() private PushTypeOptions: any = [
    {
      value: '1',
      label: 'sms'
    },
    {
      value: '2',
      label: 'push'
    },
    {
      value: '3',
      label: 'whatsapp'
    }
  ]
  @Provide() private StatusTypeOptions: any = [
    {
      value: '1',
      label: "ticketLgy.Normal"
    },
    {
      value: '2',
      label: "ticketLgy.Invalid"
    }
  ]

  @Provide() private formValue: any = {
    title: "",
    desc: "",
    label: [],
    state: ""
  };

  @Provide() private formValueRules: any = {
    title: [{ required: true, message: "请填写", trigger: "blur" }],
    label: [{ required: true, message: "请选择", trigger: "change" }],
    state: [{ required: true, message: "请选择", trigger: "change" }],
  };
  @Provide() private issearchButtonDone: boolean = false;
  @Provide() private pagnition: any = pagnition;
  @Provide() private taskTag: any = ['sms', 'push', 'whatsapp'];
  @Provide() private tagNumber: any = [];


  private created() {
    this.getMultilingualList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getMultilingualList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getMultilingualList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getMultilingualList();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getMultilingualList();
  }

  private resetForm(formName: string) {
    this.isShowDetail = false;
    let ref: any = this.$refs[formName];
    if (ref) {
      ref.resetFields();
    }
  }

  private submitForm() {
    let formName: string = "";
    formName = "formValue";
    let ref: any = this.$refs[formName];
    ref.validate((valid: any) => {
      if (valid) {
        this.submitOperation();
      } else {
        return false;
      }
    });
  }

  private searchButton() {
    this.issearchButtonDone = true;
    this.pageIndex = 1;
    this.getMultilingualList();
  }

  private addButton() {
    this.isShowDetail = true;
  }
  private editCombination(row:any) {
    this.tagNumber= [];
    let labelStr = row.tasktag.split(',');
    this.PushTypeOptions.forEach((item:any, index:any) => {
        for(let i=0; i<labelStr.length; i++) {
          if(item.label.includes(labelStr[i])) {
            this.tagNumber.push(item.value);
          }
        }
    })
    this.isEditId = row.id;
    this.isShowDetail = true;
    this.formValue.label = this.tagNumber;
    this.formValue.title = row.languagekey;
    this.formValue.desc = row.description;
    this.formValue.state = String(row.status);
  }

  private submitOperation() {
    if (this.isShowDetail) {
      this.saveMultilingual();
    }
  }
  private goContentPage(row: any) {
    let routeData: any = this.$router.resolve({
      path: "/multilingualContent",
      query: {
        id: row.id,
        langKey: row.languagekey,
        description: row.description,
        tag: row.tasktag,
        status: row.status
      },
    });
    window.open(routeData.href, "_blank");
  }

  private getMultilingualList() {
    let request: any = new ListMultilingualReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    request.setLanguagekey(this.searchForm.LanguageKey);
    request.setLanguagevalue(this.searchForm.LanguageValue);
    request.setStatus(this.searchForm.Status);
    for (var i = 0; i < this.searchForm.TaskTag.length; i++) {
      request.addTasktag(this.searchForm.TaskTag[i]);
    }
    ticketClient.listMultilingual(request, setMetaData(), (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.pagerCount = data.pageout.total;
          data.listList.forEach((item: any) => {
            let tagStr:any = [];
            item.tasktag.split(',').forEach((item:any)=>{
              tagStr.push(this.taskTag[item-1]);
            })
            item.tasktag = tagStr.join(',');
            item.ctime = timeFormat(item.ctime);
            item.utime = timeFormat(item.utime);
          });
          this.resultData = data.listList;
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
      this.issearchButtonDone = false;
    });
  }
  private saveMultilingual() {
    let request: any = new SaveMultilingualReq();
    request.setCommonin(setCommon());
    request.setId(this.isEditId);
    request.setLanguagekey(this.formValue.title);
    request.setDescription(this.formValue.desc);
    for (var i = 0; i < this.formValue.label.length; i++) {
      request.addTasktag(this.formValue.label[i]);
    }
    request.setStatus(this.formValue.state);
    
    ticketClient.saveMultilingual(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.getMultilingualList();
          this.$message({
            message: "submit successfully",
            type: "success",
          });
          this.isShowDetail = false;
          this.isEditId = null;
          this.resetForm("formValue");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
}
